import { ForwardedRef, forwardRef } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { Box } from '@zoopla-eng/zds-components/box';
import { RadioGroup } from '@zoopla-eng/zds-components/radio-group';
import { StyledLabel } from '../../question.styles';
import { AnswerData, QuestionProps } from '../../question.types';

type BasicQuestionProps = {
    name: string;
    subtitle?: string;
    label: string;
    options: QuestionProps['options'];
    onChange: (value: string) => void;
    selectedValue?: string;
    register: UseFormRegister<AnswerData>;
};

export const BasicQuestion = forwardRef(
    (
        {
            name,
            subtitle,
            label,
            options,
            onChange,
            selectedValue = '',
            register
        }: BasicQuestionProps,
        ref: ForwardedRef<HTMLDivElement>
    ) => {
        const mappedOptions = options?.map((option) => ({
            id: option.value,
            value: option.value,
            label: option.label
        }));

        return (
            <>
                <Box pb={subtitle ? '$S400' : undefined}>
                    <StyledLabel tabIndex={-1}>{label}</StyledLabel>
                </Box>
                {subtitle && <span>{subtitle}</span>}
                <RadioGroup
                    items={mappedOptions}
                    label={label}
                    onValueChange={onChange}
                    value={selectedValue}
                    {...register(name)}
                    ref={ref}
                />
            </>
        );
    }
);
